import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		min-height: calc(100vh - 90px);
		flex: 1 1 auto;
		padding: 0;
		display: flex;
		flex-direction: column;

		header {
			padding: 0;
			background-color: var(--grey-color);
		}

		.wellcome {
			flex: 1 1 auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background-color: var(--primary-color);

			p,
			strong {
				color: var(--white);
			}

			.helloUser {
				text-align: center;
				max-width: 176px;
				display: block;
				margin: 1em auto;
				/* margin-bottom: 2.5em; */
			}

			.list-pets {
				padding: 0;
				list-style: none;
				display: flex;
				align-items: flex-start;
				justify-content: center;

				li.no-cupom {
					color: var(--white);
				}

				li + li {
					margin-left: 2rem;
				}

				li {
					a {
						text-decoration: none;
					}

					div.block {
						display: flex;
						flex-direction: column;
						align-items: center;

						div.qrCode {
							position: relative;
							display: block;
							overflow: hidden;
							width: 80px;
							height: 80px;
							background-color: var(--white);
							margin: 0;

							svg.qrCode__svg {
								position: absolute;
								top: 50%;
								left: 50%;
								transform: translate(-50%, -50%);
								fill: #4d4d4d;
							}

							p.qrCode__name {
								position: absolute;
								width: 100%;
								height: 100%;
								display: flex;
								align-items: center;
								justify-content: center;
								top: 50%;
								left: 0;
								transform: translateY(-50%);
								margin: 0;
								background-color: rgba(0, 0, 0, 0.6);
								font-weight: bold;
							}
						}

						p.block__link {
							margin: 0;
							margin-top: 10px;
							text-transform: uppercase;
							font-size: 0.873em;
						}

						p.block__validated {
							margin: 0;
							text-transform: uppercase;
							font-size: 0.8em;
							font-family: "PFSquareSansProBold", sans-serif;
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		flex-direction: row;

		header {
			flex-basis: 40%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: flex-end;

			img {
				max-height: 670px;
			}
		}

		.wellcome {
			flex-basis: 60%;
			/* background-image: url(${require("@/assets/img/labyes.png")
		.default});
			background-repeat: no-repeat;
			background-position: right bottom; */

			.helloUser {
				max-width: 372px;
				font-size: 1.5em;
			}
		}
	}
`;
